module.exports = __webpack_public_path__ + "static/img/bg.ecedca17.png";